import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Home from '../pages/Home';
import News from '../pages/News';
import Company from '../pages/Company';
import CompanyDetail from '../pages/CompanyDetail';
import AllCompanies from '../pages/all-companies';
import CompanyDemo from '../pages/CompanyDemo';
import AIStrategy from '../pages/AIStrategy';
import Market from '../pages/Market';
import More from '../pages/More';
import Demo from '../pages/Demo';
import ChartDemo from '../pages/ChartDemo';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'news',
        element: <News />,
      },
      {
        path: 'company',
        element: <Company />,
      },
      {
        path: 'company-detail/:companyId',
        element: <CompanyDetail />,
      },
      {
        path: 'all-companies',
        element: <AllCompanies />,
      },
      {
        path: 'company-demo',
        element: <CompanyDemo />,
      },
      {
        path: 'ai-strategy',
        element: <AIStrategy />,
      },
      {
        path: 'market',
        element: <Market />,
      },
      {
        path: 'more',
        element: <More />,
      },
      {
        path: 'demo',
        element: <Demo />,
      },
      {
        path: 'chart-demo',
        element: <ChartDemo />,
      },
    ],
  },
]);

export default router;
